import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Button, Form, Input, Message, Modal, Popup } from "semantic-ui-react";
import { AuthStore } from "../../stores/auth-store";
import { User } from "../../stores/models/user";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";

declare var toastr: any;

interface IProps {
    userStore?: UserStore;
    authStore?: AuthStore;
}

interface IState {
    newPassword?: string;
    oldPassword?: string;
    reEnterPassword?: string;
    modalOpen?: boolean;
    errorMessage?: string;
    successMessage?: string;
}

@inject("userStore", "authStore") @observer
export class PasswordModal extends React.Component<IProps, IState>{
    constructor(props, state) {
        super(props, state);

        this.state = {
            "modalOpen": false,
            "newPassword": "",
            "reEnterPassword": "",
            "oldPassword": "",
            "errorMessage": "",
            "successMessage": ""
        };

        this.handleProfileChange = this.handleProfileChange.bind(this);
        this.setOpen = this.setOpen.bind(this);
        this.cancelAction = this.cancelAction.bind(this);
        this.confirmAction = this.confirmAction.bind(this);
    }

    async handleProfileChange(e: any, { name, value }) {
        this.setState({ [name]: value });
    }

    setOpen(state) {
        this.setState({
            "modalOpen": state
        })
    }

    cancelAction() {
        this.setState({
            "modalOpen": false,
            "newPassword": "",
            "reEnterPassword": "",
            "oldPassword": "",
            "errorMessage": "",
            "successMessage": ""
        })
    }

    async confirmAction() {
        try {
            if (this.state.newPassword.length == 0) {
                throw { "message": "Please enter your new password" };
            }
            else if (this.state.oldPassword.length == 0) {
                throw { "message": "Please enter your old password" };
            }
            else if (this.state.reEnterPassword.length == 0) {
                throw { "message": "Please confirm the password by re-enter your new password again" };
            }
            else if(this.state.oldPassword == this.state.newPassword) {
                throw { "message": "Your new password can't be the same as old password" };
            }
            else if (this.state.reEnterPassword != this.state.newPassword) {
                throw { "message": "Your new password doesn't match" };
            }
            await this.props.userStore.changePassword({
                "oldPassword": this.state.oldPassword,
                "newPassword": this.state.newPassword
            });

            this.setState({
                "successMessage": "Password is changed!",
                "errorMessage": ""
            });
        }
        catch (err) {
            log.error(err);
            this.setState({ "errorMessage": err.message });
        }
    }

    render() {
        const { authStore } = this.props;

        return (

            <Modal
                closeOnDimmerClick={false}
                onClose={() => this.setOpen(false)}
                onOpen={() => this.setOpen(true)}
                open={this.state.modalOpen}
                trigger={<Button color="yellow">Change Password</Button>}
            >
                <Modal.Header>Change your Password</Modal.Header>
                <Modal.Content>
                    {this.state.errorMessage &&
                        <div className="ui red icon message">
                            <i className="warning sign icon"></i>
                            {this.state.errorMessage}
                        </div>
                    }
                    {this.state.successMessage &&
                        <Message positive>
                            <i className="warning sign icon"></i>
                            {this.state.successMessage}
                        </Message>
                    }
                    {this.state.successMessage.length == 0 &&
                        <Form>
                            <Form.Input label="Old Password" type='password' name="oldPassword" value={this.state.oldPassword} onChange={this.handleProfileChange} />
                            <Form.Input label="New Password" type='password' name="newPassword" value={this.state.newPassword} onChange={this.handleProfileChange} />
                            <Form.Input label="Confirm Password" type='password' name="reEnterPassword" value={this.state.reEnterPassword} onChange={this.handleProfileChange} />
                        </Form>
                    }
                </Modal.Content>
                <Modal.Actions>
                    <Button color='black' onClick={() => this.cancelAction()}>
                        {this.state.successMessage.length > 0 ? "Close" : "Cancel"}
                    </Button>
                    {
                        this.state.successMessage.length == 0 &&
                        <Button
                            content="Confirm"
                            onClick={() => this.confirmAction()}
                            positive
                        />
                    }
                </Modal.Actions>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/users/password-modal.tsx